<template>
  <section class="physical-item-title-container">
    <div
      :class="{
        baopin: type === 'baopin',
        jingxuan: type === 'jingxuan',
        xianshi: type === 'xianshi',
        document: type === 'document',
      }"
      class="title"
    >
      <div class="radius"></div>
      <div class="header">
        <div class="header-container">
          <div class="left">
            <slot name="header"></slot>
          </div>
          <div class="right">
            <router-link :to="{ name: returnRouteName }">查看更多</router-link>
            <md-icon name="rectangle" size="xs"></md-icon>
          </div>
        </div>
      </div>
      <div class="content">
        <slot></slot>
      </div>
    </div>
  </section>
</template>

<script>
import { Icon } from "mand-mobile";
export default {
  props: {
    type: {
      type: String,
      default: "",
    },
  },
  components: {
    [Icon.name]: Icon,
  },
  computed: {
    returnRouteName() {
      switch (this.type) {
        case "baopin":
          return "productRecommend";
        case "jingxuan":
          return "downtickPrice";
        case "xianshi":
          return "sales";
        case "document":
          return "document";
      }
    },
  },
};
</script>

<style lang="scss">
.physical-item-title-container {
  .title {
    width: 100%;
    .radius {
      margin: 0 auto;
      width: 686px;
      height: 16px;
      opacity: 0.3;
      border-radius: 24px 24px 0px 0px;
    }
    .header {
      position: relative;
      z-index: 1;
      height: 138px;
      border-radius: 24px 24px 8px 8px;
      .header-container {
        display: flex;
        justify-content: space-between;
        margin: 0 auto;
        width: 686px;
        .left {
          display: flex;
          align-items: center;
          margin-top: 32px;
          img {
            margin-right: 6px;
            width: 36px;
            height: 36px;
          }
          p {
            font-size: 36px;
            font-weight: bold;
            line-height: 29px;
            color: #ffffff;
            text-shadow: 0px 2px 4px rgba(255, 0, 0, 0.5);
          }
        }
        .right {
          white-space: nowrap;
          display: flex;
          align-items: center;
          margin-top: 38px;
          a {
            margin-right: 6px;
            width: 112px;
            font-size: 28px;
            font-weight: 400;
            line-height: 42px;
            white-space: nowrap;
            color: #ffffff;
          }
          .md-icon {
            color: #ffffff;
          }
        }
      }
      &::after {
        content: "";
        position: absolute;
        width: 0;
        height: 0;
        border-left: 18px solid transparent;
        border-right: 18px solid transparent;
        border-bottom: 18px solid #fff;
        left: 112px;
        bottom: 25px;
      }
    }
    .content {
      position: relative;
      z-index: 2;
      margin-top: -26px;
      padding-bottom: 48px;
      width: 100%;
      min-height: 300px;
      background: #ffffff;
      border-radius: 24px 24px 0px 0px;
    }
  }
  .baopin {
    .radius {
      background: linear-gradient(90deg, #ff8231 0%, #fd606f 53%, #ef71a0 100%);
      box-shadow: 0px 6px 12px rgba(255, 27, 19, 0.27);
    }
    .header {
      background: url("../imgs/home_baopin_bg.png") no-repeat,
        -webkit-radial-gradient(circle, #fdc778 0%, #f56f45 100%);
      background-size: cover;
    }
  }
  .jingxuan {
    background-color: #ffffff;
    .radius {
      background: linear-gradient(89deg, #e5c58e 0%, #e8b15d 100%);
    }
    .header {
      background: url("../imgs/home_jingxuan_bg.png") center;
      background-position: cover;
    }
    .content {
      padding-bottom: 0 !important;
      min-height: 350px;
    }
  }
  .document {
    background-color: #ffffff;
    .radius {
      background: linear-gradient(89deg, #e5c58e 0%, #e8b15d 100%);
    }
    .header {
      background: url("../imgs/home_document_bg.png") center;
      background-position: cover;
    }
    .content {
      padding-bottom: 0 !important;
      min-height: 350px;
    }
  }
  .xianshi {
    background-color: #ffffff;
    .radius {
      box-shadow: 0px 6px 12px rgba(255, 27, 19, 0.27);
      background: linear-gradient(90deg, #ff8231 0%, #fd606f 53%, #ef71a0 100%);
    }
    .header {
      background: url("../imgs/home_xianshi_bg.png") no-repeat,
        -webkit-linear-gradient(90deg, #ff8231 0%, #fd606f 53%, #ef71a0 100%);
      &::after {
        bottom: 0;
      }
    }
  }
}
</style>
